import { render, staticRenderFns } from "./bandstaff.vue?vue&type=template&id=674aadfe&scoped=true"
import script from "./bandstaff.vue?vue&type=script&lang=js"
export * from "./bandstaff.vue?vue&type=script&lang=js"
import style0 from "./bandstaff.vue?vue&type=style&index=0&id=674aadfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674aadfe",
  null
  
)

export default component.exports